import { render } from "./RuleErrorFlags.vue?vue&type=template&id=518d7fd2"
import script from "./RuleErrorFlags.vue?vue&type=script&lang=js"
export * from "./RuleErrorFlags.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleErrorFlags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "518d7fd2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('518d7fd2', __exports__)) {
    api.reload('518d7fd2', __exports__)
  }
  
  module.hot.accept("./RuleErrorFlags.vue?vue&type=template&id=518d7fd2", () => {
    api.rerender('518d7fd2', render)
  })

}


export default __exports__